export enum QuestionType {
  COMPANY = 'COMPANY',
  FREQUENCY = 'FREQUENCY',
  MYSELF = 'MYSELF',
  ACC = 'ACC',
  SELECTED = 'SELECTED',
}
